import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import NotificationsStatusFilter from './NotificationsStatusFilter';
import {
	deleteNotification,
	readUserNotifications
} from '../../api/notificationsAPI';
import { Icon } from '@mui/material';

import './UserNotifications.scss';
import Button from '../ui/Button';
import { Checkbox } from '@mui/material';

dayjs.extend(relativeTime);

const UserNotifications = ({ notifications }) => {
	const notificationsMutation = useMutation(
		(notifications) => {
			return deleteNotification(notifications);
		}
	);
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	const [notificationState, setNotificationState] =
		useState('all');

	const [activeEliminateButton, setActiveEliminateButton] =
		useState(false);
	const onSetNotification = (notificationState) => {
		setNotificationState(notificationState);
	};
	let notificationsToDelete = [];

	const filteredNotifications = notifications.filter(
		(notification) => {
			if (notificationState === 'all') {
				return notification;
			} else if (notificationState === 'notRead') {
				return !notification.read;
			} else if (notificationState === 'read') {
				return notification.read;
			}
		}
	);

	const clickNotificationHandler = (id, study) => {
		if (!activeEliminateButton) {
			readUserNotifications(id).then((data) => {
				console.log(data);
				if (study && !activeEliminateButton) {
					navigate(study);
					queryClient.invalidateQueries('notifications');
				}
			});
			queryClient.invalidateQueries('notifications');
		}
	};
	const openMoreOptions = () => {
		setActiveEliminateButton(!activeEliminateButton);
	};

	const onChangeCheck = (checked, id) => {
		if (checked) {
			notificationsToDelete = [
				...notificationsToDelete,
				id
			];
		} else {
			let notfIndex = notificationsToDelete.indexOf(id);
			notificationsToDelete.splice(notfIndex, 1);
		}
	};

	const deleteNotifications = () => {
		notificationsMutation.mutate(notificationsToDelete, {
			onSuccess: () => {
				queryClient.invalidateQueries('notifications');
				setActiveEliminateButton(!activeEliminateButton);
			},
			onError: (error) => {
				//TODO handle delete notifications error
				setActiveEliminateButton(!activeEliminateButton);
			}
		});
	};
	return (
		<div className='user-notifications-container dropdown-menu dropdown-menu-end'>
			<div className='user-notifications-header'>
				<h4>Notifications</h4>
				<Icon
					className='more-icon'
					onClick={openMoreOptions}
				>
					more_horiz
				</Icon>
			</div>
			<NotificationsStatusFilter
				setNoticationStatus={onSetNotification}
				currentStatus={notificationState}
			/>

			{filteredNotifications.map((notification) => {
				return (
					<div
						className='notification-item-container'
						key={notification._id}
						onClick={() =>
							clickNotificationHandler(
								notification._id,
								notification.study
							)
						}
					>
						<div className='title-container'>
							<div className='notification-title'>
								{activeEliminateButton && (
									<Checkbox
										size='small'
										onChange={(event) =>
											onChangeCheck(
												event.target.checked,
												notification._id
											)
										}
									></Checkbox>
								)}
								{notification.title}
							</div>
							{notification.read === false && (
								<div className='noread-ellipse' />
							)}
						</div>
						<div className='notification-data-container'>
							<div className='notification-message'>
								{notification.message}
							</div>
							<div className='notification-time'>
								{dayjs(notification.time).fromNow()}
							</div>
						</div>
					</div>
				);
			})}
			<div className='notifications-delete-button'>
				{activeEliminateButton && (
					<Button
						className='primary-button'
						onClick={() =>
							deleteNotifications(notificationsToDelete)
						}
					>
						<Icon>delete</Icon>Delete
					</Button>
				)}
			</div>
		</div>
	);
};
export default UserNotifications;
